import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import NotificationSystem from 'react-notification-system';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import LoginPage from './containers/Authentication/loginPage';
import ResetPwd from './containers/Authentication/resetPwd';
import ForgetPwdPage from './containers/Authentication/forgetPwdPage';
import InvoiceHome from './containers/Invoices/InvoiceHome';
import TopLoader from './components/layout/TopLoader';

import * as authenticateActions from './actions/authenticateActions';
import * as notificationActions from './actions/notificationActions';
import theme from './theme';

class App extends Component {
  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.props.setNotifyRef(this.refs.notificationSystem);
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <TopLoader />
        <NotificationSystem ref="notificationSystem" />
        <Router>
          <Switch>
            <Route exact path="/login" component={LoginPage} />
            <Route exact path="/resetPwd" component={ResetPwd} />
            <Route exact path="/forgetPwd" component={ForgetPwdPage} />
            <Route path="/" component={InvoiceHome} />
          </Switch>
        </Router>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  authInfo: state.authInfo
});

const mapDispatchToProps = (dispatch) => ({
  authenticateUser: (_userName, _password) => {
    dispatch(authenticateActions.authenticateUser(_userName, _password));
  },
  setNotifyRef: (_notifyRef) => {
    dispatch(notificationActions.setNotificationRef(_notifyRef));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
